import { useRouter } from 'next/router';
import { PlayerControlButton } from '../styles';
import { useEffect, useRef, useState } from 'react';
import { IconSkipNext, IconSkipPrev } from '../../../icons';
import theme from '../../../theme';
import UsePlayerProps from '../../../Store/usePlayerProps';

const ControlBarNextPrevEpisode = () => {
  const setPlayerGlobalState = UsePlayerProps((state) => state.setPlayerState);
  const contentConfigs = UsePlayerProps((state) => state.playerState.contentConfigs);
  const router = useRouter();
  const { params } = router.query;
  const nextEpisodeId = contentConfigs?.next_episode?.id;
  const previousEpisodeId = contentConfigs?.previous_episode?.id;
  const [typeParam, setTypeParam] = useState<string>('p');
  const [isMobile, setIsMobile] = useState(false);

  const resizeTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(() => {
    handleMobileBreakpoint();
    window.addEventListener('resize', throttledHandle, { passive: true });
    return () => {
      window.removeEventListener('resize', throttledHandle);
      if (resizeTimerRef.current) {
        clearTimeout(resizeTimerRef.current);
        resizeTimerRef.current = null;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    params && handleParams();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  const throttledHandle = () => {
    if (resizeTimerRef.current !== null) return;
    resizeTimerRef.current = setTimeout(() => {
      handleMobileBreakpoint();
      resizeTimerRef.current = null;
    }, 100);
  };

  const handleMobileBreakpoint = () => {
    setIsMobile(Number(theme.breakpoints.md) > Number(window.innerWidth));
  };

  const handleParams = () => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [id, type] = params as [string, 'p' | 't'];
    setTypeParam(type);
  };

  const handleEpisode = (episodeId: string) => {
    if (episodeId) {
      router.replace(`/play/${episodeId}/${typeParam}`).then(() => {
        setPlayerGlobalState({
          contentConfigs: null,
          contentData: null,
          sources: null,
          vttData: null,
          captionState: {
            prevCaptionIndex: -1,
            selectedCaptionLang: {
              lang: 'off',
              label: 'خاموش',
            },
          },
          showingNextEpisode: true,
        });
      });
    }
  };

  return (
    <>
      {previousEpisodeId &&
        <PlayerControlButton
          size="semiLarge"
          icon={<IconSkipPrev />}
          disabled={!previousEpisodeId}
          mr={isMobile ? 1 : 2}
          onClick={() => handleEpisode(previousEpisodeId)}
        />}
      {nextEpisodeId &&
        <PlayerControlButton
          size="semiLarge"
          icon={<IconSkipNext />}
          disabled={!nextEpisodeId}
          mr={isMobile ? 1 : 2}
          onClick={() => handleEpisode(nextEpisodeId)}
        />}
    </>
  );
};

export default ControlBarNextPrevEpisode;
